import { useEffect, useLayoutEffect, useState } from 'react';
import { findScrollParent } from '../utils/domUtils';

/**
 * Locate the scroll container once the editor is in the DOM. Re-checked on
 * a timer until found — sheets mount mid-animation and can miss the first
 * lookup. Also toggles the native-scrollbar-hiding class while attached.
 *
 * Class is applied in useLayoutEffect (before paint) so we never flash a
 * native scrollbar gutter on the first frame.
 */
export const useScrollParent = (editorRootRef) => {
  const [scrollEl, setScrollEl] = useState(null);

  useLayoutEffect(() => {
    setScrollEl(findScrollParent(editorRootRef.current));
  }, [editorRootRef]);

  useEffect(() => {
    if (scrollEl) return undefined;
    const timer = setInterval(() => {
      const found = findScrollParent(editorRootRef.current);
      if (found) setScrollEl(found);
    }, 300);
    return () => clearInterval(timer);
  }, [scrollEl, editorRootRef]);

  // The minimap IS the scrollbar — hide the native one while attached.
  // useLayoutEffect: must land before paint to avoid a width jump.
  useLayoutEffect(() => {
    if (!scrollEl) return undefined;
    scrollEl.classList.add('doc-minimap-host');
    return () => scrollEl.classList.remove('doc-minimap-host');
  }, [scrollEl]);

  return [scrollEl, setScrollEl];
};
